import { useTranslation } from "react-i18next"
import GoalbankSelectionTemplate from "../common/GoalbankSelectionTemplate"
import { translateGradeLevel } from "utils/helpers"
import { useGET_setupOptionsQuery } from "redux/api/setupApi"

const CourseTemplate = ({ entity }) => {

  const { t } = useTranslation()

  const { data: setupData } = useGET_setupOptionsQuery()

  return (
    setupData && <>
                  <div style={{ fontWeight: 'bold' }}>

                    {setupData.filter(sd => sd.slug == "course_subject" && sd.is_enabled).length == 1 && 
                      <><span>{ entity.subject?.title }</span> / </>}

                    <span style={{marginLeft: '5px'}}>{ entity.domain?.title }</span> / 
                    
                    {setupData.filter(sd => sd.slug == "course_grade" && sd.is_enabled).length == 1 && 
                      <span style={{marginLeft: '5px',textTransform: 'uppercase'}}>{translateGradeLevel(entity.grade_level, true)}.{entity.term}.{entity.course_code}</span>
                    }
                    
                    <br />
                    { entity.title }
                  </div>

                  <div style={{ height: '20px' }}></div> 

                  {(entity.goalbank_selection || entity.curriculum_selection) && setupData.filter(sd => sd.slug == "course_curriculum" && sd.is_enabled).length == 1 &&  
                    <GoalbankSelectionTemplate goalbankSelection={entity.goalbank_selection} curriculumSelection={entity.curriculum_selection}/>
                  }

                  {setupData.filter(sd => sd.slug == "course_description" && sd.is_enabled).length == 1 && <>
                  <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>{ t('common.course-description') }</div>
                  <div dangerouslySetInnerHTML={{ __html: entity.description  }} />
                  <div style={{ height: '20px' }}></div>  </> }

                  {setupData.filter(sd => sd.slug == "course_assessment" && sd.is_enabled).length == 1 && <>
                  <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('common.assessment-and-measurments') }</div>
                  <div dangerouslySetInnerHTML={{ __html: entity.assessment  }} />
                  <div style={{ height: '20px' }}></div>  </> }

                  {setupData.filter(sd => sd.slug == "course_materials" && sd.is_enabled).length == 1 && <>
                  <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('common.course-materials') }</div>
                  <div dangerouslySetInnerHTML={{ __html: entity.course_materials  }} />
                  <div style={{ height: '20px' }}></div>  </> }

                  {setupData.filter(sd => sd.slug == "course_technologies" && sd.is_enabled).length == 1 && <>
                  <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('common.course-technologies') }</div>
                  <div dangerouslySetInnerHTML={{ __html: entity.technologies  }} />
                  <div style={{ height: '20px' }}></div>  </> }

                  {setupData.filter(sd => sd.slug == "course_instructions" && sd.is_enabled).length == 1 && <>
                  <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('common.course-instructions-and-activities') }</div>
                  <div dangerouslySetInnerHTML={{ __html: entity.instructions  }} />
                  <div style={{ height: '20px' }}></div>  </> }

                  {setupData.filter(sd => sd.slug == "course_outline" && sd.is_enabled).length == 1 && <>
                  <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('common.course-outline') }</div>
                  <div dangerouslySetInnerHTML={{ __html: entity.outline  }} />
                  <div style={{ height: '20px' }}></div>  </> }

                  {setupData.filter(sd => sd.slug == "course_learner_support" && sd.is_enabled).length == 1 && <>
                  <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('common.learner-support') }</div>
                  <div dangerouslySetInnerHTML={{ __html: entity.learner_support  }} />
                  <div style={{ height: '20px' }}></div>  </> }

                  {setupData.filter(sd => sd.slug == "course_plagiarism" && sd.is_enabled).length == 1 && <>
                  <div style={{ fontWeight: 'bold', marginBottom: '5px'  }}>{ t('common.plagiarism') }</div>
                  <div dangerouslySetInnerHTML={{ __html: entity.plagiarism  }} />
                  <div style={{ height: '20px' }}></div>  </> }

                  {setupData.filter(sd => sd.slug == "course_performance_expectations" && sd.is_enabled).length == 1 && <>
                  <div style={{ fontWeight: 'bold' }}>{ t('common.performance-expectations') }</div>
                  <div>{
                      entity.components.map(c => <div key={c.id} style={{marginTop: '10px'}}>{ c.title}: <b>{c.importance}%</b></div>)
                    }</div> </> }

      
    </>
  )
}

export default CourseTemplate
